export default __webpack_public_path__ + "b54e1fc08496ee4414616e5da116ccdd.png";